import {
    SkeletonTitle,
    SkeletonLine,
    SkeletonButton,
    SkeletonToggle,
    SkeletonContainer,
} from "./SkeletonElements";

const OnlineBookingsSkeleton = () => {
    return (
        <div className="mb-8">
            <SkeletonTitle className="mb-4" />

            <div className="flex items-center gap-3 mt-2">
                <SkeletonToggle />
                <SkeletonLine width="w-96" />
            </div>

            <SkeletonContainer className="mt-4">
                <SkeletonLine />
                <SkeletonLine width="w-3/4" />
            </SkeletonContainer>

            <div className="flex flex-col items-center mt-4">
                <SkeletonButton />
            </div>
        </div>
    );
};

export default OnlineBookingsSkeleton;
